/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterFcmTokenRequest as DigiworkMaitreDPosDtoAdvertiserRegisterFcmTokenRequest } from '../../models/Digiwork/MaitreD/Pos/DTO/Advertiser/register-fcm-token-request';

export interface RegisterFcmToken_2$Params {
      body?: DigiworkMaitreDPosDtoAdvertiserRegisterFcmTokenRequest
}

export function registerFcmToken_2(http: HttpClient, rootUrl: string, params?: RegisterFcmToken_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, registerFcmToken_2.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

registerFcmToken_2.PATH = '/api/gmn/User/registerfcmtoken';
